const gameStates = {
  INTRO: 0,
  QUESTION_1: 1,
  QUESTION_2: 2,
  QUESTION_3: 3,
  QUESTION_4: 4,
  QUESTION_5: 5,
  QUESTION_6: 6,
  QUESTION_7: 7,
  QUESTION_8: 8,
  QUESTION_9: 9,
  QUESTION_10: 10,
  ENDED: 11,
}

export default gameStates;
